import { render } from "./CardBarChart.vue?vue&type=template&id=95ad004e"
import script from "./CardBarChart.vue?vue&type=script&lang=js"
export * from "./CardBarChart.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__